import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const ProductFormBasic = ({
  formData,
  setFormData,
  brands,
  subBrands,
  categories,
  menuOptions,
  subMenuOptions,
  onBrandChange,
  onMenuChange
}) => {
  return (
    <>
      <div className="space-y-2">
        <Label>Product Name *</Label>
        <Input value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required />
      </div>

      <div className="col-span-2 space-y-2">
        <Label>Description</Label>
        <Input value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} />
      </div>

      <div className="space-y-2">
        <Label>Parent Brand *</Label>
        <Input
          list="brands-list"
          value={formData.brand}
          onChange={(e) => onBrandChange(e.target.value)}
          placeholder="Select or type parent brand..."
          required
        />
        <datalist id="brands-list">
          {brands.map((brand) => <option key={brand} value={brand} />)}
        </datalist>
      </div>

      <div className="space-y-2">
        <Label>Sub Brand</Label>
        <Input
          list="sub-brands-list"
          value={formData.sub_brand}
          onChange={(e) => setFormData({ ...formData, sub_brand: e.target.value })}
          placeholder={formData.brand ? "Select sub-brand..." : "Select parent brand first"}
          disabled={!formData.brand}
        />
        <datalist id="sub-brands-list">
          {subBrands.map((sb) => <option key={sb} value={sb} />)}
        </datalist>
      </div>

      <div className="space-y-2">
        <Label>Category *</Label>
        <Input
          list="categories-list"
          value={formData.category}
          onChange={(e) => setFormData({ ...formData, category: e.target.value })}
          required
        />
        <datalist id="categories-list">
          {categories.map((cat) => <option key={cat} value={cat} />)}
        </datalist>
      </div>

      <div className="space-y-2">
        <Label>Menu Group</Label>
        <Input
          list="menu-list"
          value={formData.menu_option}
          onChange={(e) => {
            const val = e.target.value;
            setFormData({ ...formData, menu_option: val, sub_menu: '' });
            if (onMenuChange) onMenuChange(val);
          }}
        />
        <datalist id="menu-list">
          {menuOptions.map((m) => <option key={m} value={m} />)}
        </datalist>
      </div>

      <div className="space-y-2">
        <Label>Sub Menu</Label>
        <Input
          list="sub-menu-list"
          value={formData.sub_menu || ''}
          onChange={(e) => setFormData({ ...formData, sub_menu: e.target.value })}
          placeholder={formData.menu_option ? "Select sub-menu..." : "Select menu group first"}
          disabled={!formData.menu_option}
        />
        <datalist id="sub-menu-list">
          {(subMenuOptions || []).map((sm) => <option key={sm} value={sm} />)}
        </datalist>
      </div>
    </>
  );
};

export default ProductFormBasic;
